<div style="max-width: 100%">
  <dx-data-grid
    class="h-100"
    [dataSource]="dataSource"
    [remoteOperations]="false"
    [allowColumnReordering]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [showBorders]="true"
    [showColumnHeaders]="true"
    mode="multiple"
    (onRowUpdated)="onRowUpdated($event)"
    (onRowRemoved)="onRowRemoved($event)"
    (onRowInserted)="onRowInserted($event)"
    (onInitNewRow)="onInitNewRow($event)"
  >
    <dxo-paging [pageSize]="50"></dxo-paging>
    <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-editing
      mode="cell"
      [allowUpdating]="isManager()"
      [allowDeleting]="isManager()"
      [allowAdding]="isManager()"
    ></dxo-editing>

    <dxi-column dataField="ftpServerId" caption="{{ 'Ftp Server' | translate }}">
      <dxo-lookup [dataSource]="ftpServers" valueExpr="id" displayExpr="name"></dxo-lookup>
    </dxi-column>

    <dxi-column
      dataField="time"
      dataType="datetime"
      caption="{{ 'Uhrzeit' | translate }}"
      editCellTemplate="timeTemplate"
      showEditorAlways="true"
    >
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <div *dxTemplate="let cellInfo of 'timeTemplate'">
      <dx-date-box
        [(value)]="cellInfo.value"
        (onValueChanged)="cellInfo.setValue($event.value)"
        type="time"
        pickerType="list"
        [interval]="15"
      ></dx-date-box>
    </div>

    <dxi-column
      dataField="lastRun"
      dataType="datetime"
      caption="{{ 'Letzte automatische Ausfuehrung' | translate }}"
      editCellTemplate="lastRunTemplate"
      showEditorAlways="true"
      [allowEditing]="false"
    ></dxi-column>
    <div *dxTemplate="let cellInfo of 'lastRunTemplate'">
      <dx-date-box
        [(value)]="cellInfo.value"
        (onValueChanged)="cellInfo.setValue($event.value)"
        type="datetime"
        [readOnly]="true"
      ></dx-date-box>
    </div>

    <dxi-column
      dataField="autoCreateContainerPerSupplier"
      caption="{{ 'Container je Lieferant automatisch anlegen' | translate }}"
      dataType="boolean"
    ></dxi-column>
    <dxi-column
      dataField="createCategoriesFromDiscountGroup"
      caption="{{ 'Kategorien aus Rabattgruppen anlegen' | translate }}"
      dataType="boolean"
    ></dxi-column>

    <dxi-column dataField="active" caption="{{ 'Aktiv' | translate }}" [allowEditing]="true"
                dataType="boolean"></dxi-column>

    <dxi-column cellTemplate="diffCellTemplate" editCellTemplate="emptyTemplate">
      <div *dxTemplate="let data of 'diffCellTemplate'">
        <dx-button
          style="text-align: right; float: right"
          text="{{ 'Manuell ausführen' | translate }}"
          (onClick)="run(data)"
          icon="redo"
        ></dx-button>
      </div>
      <div *dxTemplate="let data of 'emptyTemplate'"></div>
    </dxi-column>
  </dx-data-grid>
</div>
